<h3 mat-dialog-title class="title">Filters</h3>
<mat-dialog-content class="body">
    <form [formGroup]="form">
        <mat-form-field>
            <mat-label>Title / Filename / Doc Sub-Type</mat-label>
            <input matInput formControlName="search"/>
        </mat-form-field>
        <div class="form-field-container">
            <label>Document Sub-Type</label>
            <app-doc-sub-type-multiselect
                [subtypes]="subTypes"
                [grouped]="useDocTypeGrouping"
                panelWidth=""
                formControlName="type"
                placeholder="Select document sub-types">
            </app-doc-sub-type-multiselect>
        </div>
        <div class="grouped-form-fields">
            <mat-form-field class="narrow-select">
                <mat-select panelWidth="" formControlName="dateFilterType">
                    <mat-option value="eq">&equals;</mat-option>
                    <mat-option value="ge">&gt;&equals;</mat-option>
                    <mat-option value="le">&lt;&equals;</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Document Date</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="date">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="footer" align="end">
    <button mat-button mat-raised-button mat-dialog-close (click)="onCancelClick()">Cancel</button>
    <button mat-button mat-raised-button (click)="onClearClick()">Clear</button>
    <button mat-button mat-raised-button color="primary" [mat-dialog-close]="{ value: this.form.value }" cdkFocusInitial>Filter</button>
</mat-dialog-actions>